import { render } from "./UserProfileDetails.vue?vue&type=template&id=e9776ad4"
import script from "./UserProfileDetails.vue?vue&type=script&lang=js"
export * from "./UserProfileDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__